<cc-percentage-based-downloader [data]="data"></cc-percentage-based-downloader>
